import * as React from "react";

import FullScreenForm from "../../components/Forms/EditableDoc/SignupForm/FullScreenForm";

export default () => {
  return <FullScreenForm/>;
};
